<script setup>
import { useScrollToTop } from "@/mixins/utils/scroll-to-top-on-init";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";

definePageMeta({
  middleware: "authenticated"
});

const { trackPage } = useTrackingPage();
const { scrollToTop } = useScrollToTop();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
  scrollToTop();
});

const { layout } = storeToRefs(useContextStore());

const conf = useRuntimeConfig();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[`/components/pages/mon-compte/${layout.value}.vue`]
  );
});
</script>

<template>
  <div>
    <component :is="component" />
  </div>
</template>
